import { createWebHashHistory, createRouter } from "vue-router";

import routes from "./static";
const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,

  scrollBehavior(to: any, from: any, savedPosition: any) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});
export default router;
